import { useState } from 'react'
import { Button } from '@creanizer/ui'
import { Input } from '@creanizer/ui'
import { Label } from '@creanizer/ui'
import { Textarea } from '@creanizer/ui'
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@creanizer/ui'
import type { SavedLocation } from '@creanizer/types'

interface LocationEditModalProps {
  location: SavedLocation
  onSave: (updates: Partial<SavedLocation>) => void
  onClose: () => void
}

export function LocationEditModal({ location, onSave, onClose }: LocationEditModalProps) {
  const [title, setTitle] = useState(location.title)
  const [memo, setMemo] = useState(location.memo || '')
  const [tags, setTags] = useState(location.tags?.join(', ') || '')

  const handleSave = () => {
    onSave({
      title,
      memo,
      tags: tags ? tags.split(',').map(t => t.trim()).filter(Boolean) : []
    })
  }

  return (
    <Dialog open={true} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>ロケーション情報を編集</DialogTitle>
        </DialogHeader>
        
        <div className="space-y-4">
          <div>
            <Label htmlFor="title">タイトル</Label>
            <Input
              id="title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </div>
          
          <div>
            <Label htmlFor="memo">メモ</Label>
            <Textarea
              id="memo"
              value={memo}
              onChange={(e) => setMemo(e.target.value)}
              rows={4}
              placeholder="自由にメモを記入できます"
            />
          </div>
          
          <div>
            <Label htmlFor="tags">タグ（カンマ区切り）</Label>
            <Input
              id="tags"
              value={tags}
              onChange={(e) => setTags(e.target.value)}
              placeholder="例: 危険地帯, 美しい景色, 資源豊富"
            />
          </div>
        </div>
        
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            キャンセル
          </Button>
          <Button onClick={handleSave}>
            保存
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}